import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

import { useGoogleAnalytics } from "./useGoogleAnalytics";

interface GoogleAnalyticsOptions {
  measurementIds?: string[];
  userId?: string;
}

export function useGoogleAnalyticsSetup(options: GoogleAnalyticsOptions) {
  const location = useLocation();
  const { measurementIds, userId } = options;
  const { gaTrackEvent } = useGoogleAnalytics();
  const regexUUID =
    /([0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})/g;

  const gaInitialize = (measurementIds: string[]) => {
    const initOptions = measurementIds.map((key) => {
      return {
        trackingId: key,
        gtagOptions: {
          send_page_view: false,
        },
      };
    });

    ReactGA.initialize(initOptions);
  };

  useEffect(() => {
    if (measurementIds && measurementIds?.length > 0) {
      gaInitialize(measurementIds);
    }
  }, [measurementIds]);

  useEffect(() => {
    // this is called on login and log out automatically; it should send undefined when logged out
    ReactGA.set({ user_id: userId });
  }, [userId]);

  useEffect(() => {
    // replace UUIDs with "UUID" for report normalization purposes
    const path = window.location.pathname.replace(regexUUID, "UUID");
    // rebuild the full URL (without any trailing hash) to pass up to GA
    const full_url_without_hash = `${window.location.protocol}//${
      window.location.hostname
    }${
      !["443", "80"].includes(window.location.port)
        ? `:${window.location.port}`
        : ""
    }${path}${window.location.search}`;

    gaTrackEvent("page_view", {
      page_location: full_url_without_hash,
      page_referrer: document.referrer,
    });
  }, [location]);
}
